import React, { ReactNode, useState } from 'react';
import { Paper } from '@mui/material';
import ApplicationReports from 'pages/Reports';
import { FormSelect } from 'components/form/FormSelect';
import { PageContainer } from 'components/shared/Page/PageContainer';

import { ReportTypes } from '../../../types';
import { REPORT_OPTIONS } from '../../../constants';
import { LenderPerformance } from '../../components';

export const DealerReportsPage = () => {
  const [selectedReport, setSelectedReport] = useState<ReportTypes>(ReportTypes.ApplicationReports);

  const renderByType: Record<ReportTypes, ReactNode> = {
    [ReportTypes.ApplicationReports]: <ApplicationReports />,
    [ReportTypes.LenderPerformance]: <LenderPerformance />,
  };

  return (
    <PageContainer>
      <Paper sx={{ p: 2, mb: 2 }}>
        <FormSelect
          sx={{ width: '300px' }}
          value={selectedReport}
          options={REPORT_OPTIONS}
          onValueChange={value => setSelectedReport(value as ReportTypes)}
        />
      </Paper>

      {renderByType[selectedReport]}
    </PageContainer>
  );
};
